<template lang="jade">
  div.zoom(:style="setHeight")
    pdf(:src="currentSheetPdf")
</template>

<script>
  import pdf from 'vue-pdf'

  export default {
    props: ['setHeight'],
    computed: {
      currentSheetPdf () {
        return this.$store.getters.currentSheetPdf[0]
      }
    },
    components: {
      pdf
    }
  }
</script>

<style scoped>
  .zoom {
    width: 157% !important;
  }
</style>



// WEBPACK FOOTER //
// PdfView.vue?06d55aa2